<template>
  <div>
    <h3>
      {{ titleobj.projectLeaderName }}负责的项目【{{ titleobj.name }}】已开始{{
        titleobj.useTime
      }}天，当前进度 “{{ titleobj.stateName }}”
    </h3>
    <div class="tab-list">
      <Row
        :gutter="8"
        style="margin: 0px 0 0 0; width: 100%"
        v-if="menus && menus.length > 0"
      >
        <Menu
          mode="horizontal"
          :active-name="menu_name"
          @on-select="selectMenu"
          style="width: 100%"
        >
          <div v-for="(v, k) in menus"  style="display:inline-block;" :key="k">
            <MenuItem :name="v.name" v-auth="v.auth" @click="v.onClick">
              <Badge
                :overflow-count="10000000"
                v-if="v.badge && v.badge.count"
                :count="v.badge.count"
                :offset="[18, -3]"
              >
                {{ v.label }}
              </Badge>
              <span v-if="!(v.badge && v.badge.count)">
                {{ v.label }}
              </span>
            </MenuItem>
          </div>
        </Menu>
      </Row>
    </div>
    <div style="margin-top: 10px">
      <Button type="info" ghost @click="this.toAdd" v-if="this.customerId != 0"
        >新增供应商</Button
      >
      <Button type="info" ghost @click="this.toAdd" v-if="this.customerId == 0"
        >新增客户</Button
      >
    </div>
    <Row :gutter="8" style="margin: 10px 0 0 0; width: 100%">
      <Table
        :columns="tableCols"
        :data="data2"
        :table="table"
        :border="table.border"
        :stripe="table.stripe"
        :header="table.header"
        :footer="table.footer"
        :columns-list="tableCols"
        style="width: 100%"
      >
      </Table>
    </Row>
  </div>
</template>
<script>
let id = window.localStorage.getItem("projectId");
import Addsupplier from "./addsupplier.vue";

let customerId = window.localStorage.getItem("customerId");
export default {
  components: { Addsupplier },
  data() {
    return {
      menus: [
        {
          label: "项目全景",
          name: "panorama",
        },
        {
          label: " 跟进记录",
          name: "schedule_Info",
        },
        {
          label: "任务",
          name: "task_Info",
        },
        {
          label: Number(customerId) == 0 ? "客户" : "供应商",
          name: "supplier_List",
        },
       {
          label: "合同",
          name: "contract_Info",
        },
        {
          label: "发票/支付",
          name: "invoice_Info",
        },
      ],
      actions: [],
      customerId: "",
      table: {
        mname: "relationship",
        key: "id",
        url: {},
        output: false,
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: Number(customerId) == 0 ? "客户名称" : "供应商名称",
          key: "supplierName",
          minWidth: 120,
          tooltip: "true",
          align: "left",
        },
        {
          title: "状态",
          key: "state",
          width: 140,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.state === 1
                ? "提需求"
                : row.state === 2
                ? "需求沟通"
                : row.state === 3
                ? "正式立项"
                : row.state === 4
                ? "预算申报"
                : row.state === 5
                ? "上会通过"
                : row.state === 6
                ? "院内谈判"
                : row.state === 7
                ? "公开调研"
                : row.state === 8
                ? "招投标"
                : row.state === 9
                ? "签订合同"
                : row.state === 10
                ? "服务中"
                : row.state === 11
                ? "lost"
                : row.state === 12
                ? "潜在"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "性质",
          key: "supplierNature",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.supplierNature === 1 ? "厂家" : row.supplierNature === 2 ? "代理" : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "项目经理",
          width: 120,
          tooltip: "true",
          key: "projectManager",
          align: "center",
        },
        {
          title: "项目经理电话",
          width: 140,
          tooltip: "true",
          key: "telephone",
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 180,
          fixed: "right",
          render: (vm, param) => {
            const row = param.row;
            return (
              <div>
                <Button
                  size="small"
                  onClick={() => this.toinfo(row)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  详情
                </Button>
                <Button
                  size="small"
                  onClick={() => this.handleEdit(row)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  编辑
                </Button>
                <Button
                  size="small"
                  onClick={() => this.toDel(row)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                  }}
                >
                  删除
                </Button>
              </div>
            );
          },
        },
      ],
      data2: [],
      projectId: window.localStorage.getItem("projectId"),
      titleobj: {},
    };
  },
  created() {
    let route = this.$route;
    if (route) {
      this.menu_name = route.name;
    }
    this.customerId = customerId;
    this.load(this.projectId);
    this.initData(this.projectId);
  },
  methods: {
    async initData(id) {
      if (id) {
        let res = await $utils.api.load(`/admin/system/management/${id}`);
        try {
          if (res.code == 200) {
            this.titleobj = res.data;
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    async load(id) {
      let d = { projectId: id };
      let res = await $utils.api.load(`/admin/system/relationship/list`, d, "get");
      if (res.code == 200 && res.rows.length > 0) {
        this.data2 = res.rows;
      }
    },
    toDel(row) {
      let q = { supplierId: row.id, projectId: Number(id) };
      $utils.api
        .load(
          `/admin/system/relationship/delete?projectId=${q.projectId}&supplierId=${q.supplierId}`,
          "",
          "DELETE"
        )
        .then((res) => {
          if (res.code == 200) {
            this.$Modal.remove();
            $utils.toast.success(res.msg);
            setTimeout(() => {
              location.reload();
            }, 1000);
          }
        });
    },
    toAdd() {
      this.$Modal.success({
        closable: true,
        title: Number(customerId) == 0 ? "新增客户" : "新增供应商",
        width: "800px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <Addsupplier
                onOnCancel={() => {
                  this.onCancel();
                }}
              />
            </div>
          );
        },
      });
    },
    onCancel() {
      this.$Modal.remove();
      setTimeout(() => {
        location.reload();
      }, 1000);
    },
    selectMenu(name) {
      if (this.menu_name !== name) {
        setTimeout(() => {
          this.$destroy();
        }, 100);
        $utils.url.push({ name: name, params: { refresh: true } });
      }
    },
    toinfo(row) {
      $utils.url.push({
        name: "supplier_Info",
        query: {
          info: row,
        },
      });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "supplier_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
